'use strict';
var $player = null;
$('.video-content-card').on("click", function() {
	var videoKey = $(this).attr('data-video-key');
	$player = new Vimeo.Player(document.getElementById('videoPlayer'));
	$player
		.loadVideo(videoKey)
		.then(function(id) {
			$player.play();
			$('#video-modal').addClass('show-modal');
			$('.video-box-container').addClass('show-this');
		});
});

$('.close-button, #video-modal-overlay').on('click', function () {
	$player.pause();
	$player.setCurrentTime(0);
	$('body').css('overflow', 'visible');
	$('#video-modal').removeClass('show-modal');
	$('.video-box-container').removeClass('show-this');
});

